<app-legal-page titleKey="LEGAL.PRIVACY.TITLE" [introKey]="introKey" [sections]="sections"></app-legal-page>